import React from 'react';
import PropTypes from 'prop-types';
import { TableCardHeader } from 'react-md';
import { injectIntl } from 'react-intl';
import ContestDialog from '../Journey/ContestDialog';

const ContestedTableActions = ({
  onReportClick, onRejectClick, intl: { formatMessage }, userAttributes, selectedRows,
}) => (
  <TableCardHeader
    title={formatMessage({ id: 'menu.title.contested' })}
    className="card-title-header"
    visible={selectedRows.length > 0}
    contextualTitle={`${selectedRows.length} ${formatMessage({ id: 'journeyDetails.itemsSelected' }, { value: selectedRows.length })}`}
    actions={[
      <ContestDialog
        segment={selectedRows}
        onClickReportError={onReportClick}
        onClickRejectError={onRejectClick}
        userAttributes={userAttributes}
        style={{ color: '#FFFFFF' }}
      />,
    ]}
  />
);

ContestedTableActions.propTypes = {
  onReportClick: PropTypes.func,
  onRejectClick: PropTypes.func,
  intl: PropTypes.object,
  userAttributes: PropTypes.shape({
    isPsy: PropTypes.bool.isRequired,
  }).isRequired,
  selectedRows: PropTypes.array.isRequired,
};

export default injectIntl(ContestedTableActions);



// WEBPACK FOOTER //
// ./src/components/Contested/ContestedTableActions.js